
import { defineComponent, computed, onMounted, ref, nextTick, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { GlobalDataProps } from '../store/index'
import WorksList from '../components/WorksList.vue'
import useLoadMore from '../hooks/useLoadMore'
export default defineComponent({
  components: {
    WorksList
  },
  setup() {
    const store = useStore<GlobalDataProps>()
    const router = useRouter()
    const works = computed(() => store.state.templates.works)
    const total = computed(() => store.state.templates.totalWorks)
    const isLoading = computed(() => store.getters.isOpLoading('fetchWorks'))
    const isTemplate = ref(0)
    const searchText = ref('')
    const pageState = reactive({
      pageIndex: 0,
      pageSize: 4
    })
    const searchParams = computed(() => ({ ...pageState, isTemplate: isTemplate.value, title: searchText.value }))
    const getWorks = () => {
      store.dispatch('fetchWorks', { searchParams: searchParams.value })
    }
    const onSearch = () => {
      pageState.pageIndex = 0
      getWorks()
    }
    onMounted(() => {
      getWorks()
    })
    const { isLastPage, loadMorePage, isFirstPage, loadPrevPage, pageIndex, requestParams, goToPage, totalPage } =
      useLoadMore('fetchWorks', total, searchParams.value)

    const onDelete = (id: number) => {
      store.dispatch('deleteWork', { urlParams: { id } })
    }
    const onCopy = (id: number) => {
      store.dispatch('copyWork', { urlParams: { id } }).then(({ data }) => {
        router.push(`/editor/${data.id}`)
      })
    }
    const changeCategory = (key: any) => {
      isTemplate.value = key
      pageIndex.value = 0
      requestParams.isTemplate = key
      nextTick(() => {
        store.dispatch('fetchWorks', { searchParams: searchParams.value })
      })
    }

    return {
      works,
      getWorks,
      onDelete,
      onCopy,
      isLoading,
      total,
      changeCategory,
      loadMorePage,
      isLastPage,
      isFirstPage,
      loadPrevPage,
      searchText,
      pageIndex,
      onSearch,
      goToPage,
      totalPage
    }
  }
})
